<template>
	<v-dialog persistent width="auto" v-model="showDialog" v-if="selectedConsumable">
		<v-card style="min-height: 50vh; max-height: 80vh; width: 33vw; min-width: 400px" class="d-flex flex-column">
			<v-card-title class="card-header text-left fixed-card-title2">
				<v-row no-gutters>
					<v-col class="align-center d-flex" cols="10">
						<v-toolbar-title>{{ $t('consumable') }} {{ $t('details') }}</v-toolbar-title>
					</v-col>
					<v-spacer />
					<v-icon @click="$emit('closeDialog')" class="white-icon">mdi-close</v-icon>
				</v-row>
			</v-card-title>
			<v-card-text class="pa-4 flex-grow-1 d-flex flex-column overflow-y-auto">
				<div class="flex-grow-1">
					<v-row dense class="ma-0">
						<v-col cols="8" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('consumable-model-name') }}:</div>
							<div class="text-body-1">{{ selectedConsumable.consumableModel.name }}</div>
						</v-col>
						<v-col cols="4" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('lot-number') }}:</div>
							<div class="text-body-1">{{ selectedConsumable.lotNumber }}</div>
						</v-col>
						<v-col cols="8" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('organization-name') }}:</div>
							<div
								class="text-body-1"
								:style="{ color: selectedConsumable.organization?.institutionName ? '' : 'red' }">
								{{ selectedConsumable.organization?.institutionName ?? $t('unassigned') }}
							</div>
						</v-col>
						<v-col cols="4" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('hospital-name') }}:</div>
							<div class="text-body-1" :style="{ color: selectedConsumable.location?.hospitalName ? '' : 'red' }">
								{{ selectedConsumable.location?.hospitalName ?? $t('unassigned') }}
							</div>
						</v-col>
						<v-col cols="8" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('supplier-name') }}:</div>
							<div class="text-body-1">{{ selectedConsumable.supplierName }}</div>
						</v-col>
						<v-col cols="4" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('quantity-total') }}:</div>
							<div class="text-body-1">
								{{ selectedConsumable.quantityTotal }} {{ selectedConsumable.consumableModel.unitOfMeasure }}
							</div>
						</v-col>
						<v-col cols="8" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('cost-per-unit') }}:</div>
							<div class="text-body-1">{{ selectedConsumable.costPerUnit }} {{ selectedConsumable.currency }}</div>
						</v-col>
						<v-col cols="4" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('quantity-available') }}:</div>
							<div class="text-body-1">
								{{ selectedConsumable.quantityAvailable }} {{ selectedConsumable.consumableModel.unitOfMeasure }}
							</div>
						</v-col>
						<v-col cols="8" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('sell-price-per-unit') }}:</div>
							<div class="text-body-1">
								{{ selectedConsumable.sellPricePerUnit }} {{ selectedConsumable.sellCurrency }}
							</div>
						</v-col>
						<v-col cols="4" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('sell-quantity') }}:</div>
							<div class="text-body-1">{{ selectedConsumable.sellQuantity }}</div>
						</v-col>
						<v-col cols="8" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('shipment-cost') }}:</div>
							<div class="text-body-1">
								{{ selectedConsumable.shipmentCost }} {{ selectedConsumable.shipmentCurrency }}
							</div>
						</v-col>
						<v-col cols="4" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('shipment-date') }}:</div>
							<div class="text-body-1">
								{{ selectedConsumable.shipmentDate ? formatTimestamp(selectedConsumable.shipmentDate) : '-' }}
							</div>
						</v-col>
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('tracking-number') }}:</div>
							<div class="text-body-1">
								{{ selectedConsumable.trackingNumber || '-' }}
							</div>
						</v-col>
					</v-row>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-row dense class="ma-0">
					<v-col class="text-left">
						<span class="text-subtitle-1 font-weight-bold">{{ $t('expiration-date') }}:</span>
						<span class="text-body-1">
							{{ formatTimestamp(selectedConsumable.expirationDate) }}
						</span>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { formatTimestamp } from '@/utils/utilities';
export default {
	name: 'ConsumableViewDialog',
	props: ['showDialog', 'selectedConsumable'],
	methods: {
		formatTimestamp,
	},
};
</script>
